import React, { useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';


import back_arrow from "../../assets/images/back_arrow.png";
import { type } from "@testing-library/user-event/dist/type";
import BackSecion from "../common/header";


/**
 * Renders Component.
 * @return {FeeStu} renders Component.
 */
export default function FeeStu() {
    useEffect(() => { }, []);

    return (
        <>
            <div className="cmmn px-3">
                <Container className="d-flex flex-column height_100vh">
                <BackSecion name="Fees" navigate_action="/home" />



                    <Row className="mt-075">
                        <Col xs="12" className="mx-auto fee_std_bg rounded-3 px-3 py-2">
                            <Row className="justify-content-between">
                                <Col xs="6">
                                    <p className="f-13 fw-bold">User Fee Type</p>
                                </Col>
                                <Col xs={4} className="text-end f-14 fw-bold text-white ms-auto">
                                        <Form.Check  aria-label="option 1"/>

                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col xs={5} className="f-12 status_clr">
                                    <p className="m-0">Total Fee</p>
                                    <div> ₹  1000</div>
                                    </Col>
                                <Col xs={5} className="f-12 status_clr">
                                    <p className="m-0">Due Date</p>
                                    <div>05 Dec 2020</div>



                                </Col>

                            </Row>
                            <Row className="mb-3">
                        <Col xs={5} className="f-12">
                            <p className="mb-0">Due Date</p>
                            <p>03 Jun 2020</p>
                        </Col>
                        <Col xs={5} className="f-12">
                            <p className="mb-0">Status</p>
                            <p className="nt_paid_clr">Yet to be paid</p>
                        </Col>
                    </Row>

                        </Col>

                    </Row>

                    <Row className="mt-075">
                        <Col xs={12} className="mx-auto fee_gry rounded-3 px-3 py-3">
                            <Row className="d-flex justify-content-between">
                                <Col xs={6}>
                                    <p className="f-13 fw-bold">User Fee Type</p>

                                </Col>
                                <Col xs={4} className="text-end f-14 fw-bold text-white ms-auto">
                                <Form.Check  aria-label="option 1"/>

                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col xs={5} className="f-12 status_clr">
                                    <p className="mb-0">Total Fee</p>
                                    <div>
                                        ₹  1000</div>



                                </Col>
                                
                            </Row>
                            <Row>
                        <Col xs={5} className="f-12">
                            <p className="mb-0">Due Date</p>
                            <p>03 Jun 2020</p>
                        </Col>
                        <Col xs={5} className="f-12">
                            <p className="mb-0">Status</p>
                            <p className="nt_paid_clr">Yet to be paid</p>
                        </Col>
                    </Row>

                        </Col>

                    </Row>


                    <Row className="mt-075">
                        <Col xs={12} className="mx-auto fee_gry rounded-3 px-3 py-2">
                            <Row className="justify-content-between">
                                <Col xs={6} className="col-6">
                                    <p className="f-13">Fee Type</p>
                                </Col>
                            </Row>

                           
                            <Row className="mb-3">
                                <Col xs={5} className="f-12 status_clr">
                                    <p className="m-0">Total Fee</p>
                                    <div> ₹  1000</div>
                                    </Col>
                                <Col xs={5} className="f-12 status_clr">
                                    <p className="m-0">Due Date</p>
                                    <div>05 Dec 2020</div>



                                </Col>

                            </Row>
                            <Row className="mb-3">
                        <Col xs={5} className="f-12">
                            <p className="mb-0">Due Date</p>
                            <p>03 Jun 2020</p>
                        </Col>
                        <Col xs={5} className="f-12">
                            <p className="mb-0">Status</p>
                            <p className="paid_clr">Paid</p>
                        </Col>
                    </Row>
                        </Col>

                    </Row>
                    <Row className="mt-17 mt-auto mb-3 justify-content-between">
                        <Col xs={3} className="p-0">
                            <p className="mb-0 f-11 status_clr">Total Amount</p>
                            <p className="fw-bold f-14 mb-0">$ 3500</p>
                        </Col>
                        <Col xs={8} className="pe-0 d-grid gap-2">
                            <button className="btn btn-primary btn-radius rounded-3 f-13">Pay now</button>
                            </Col>
                    </Row>
                </Container>


            </div>
        </>
    );
}

